import React from 'react';

export const TileBig = (props) => {
    const navigator_item_step_2 = require('./images/navigator_item_step_2.png');

    function setClickedItemID() {
        //in case of subitems
        if (typeof (props.setCurrentItem) === 'function') {
            props.setCurrentItem(parseInt(props.id));
        }
    }

    let s = props.clicktValue;
    let image = require('./images/' + props.src)
    return (
        <div className={"col mb-30"}>
            <div id={props.id}
                onClick={setClickedItemID}
                className={"card bg-white text-black h-100 border-0 card-image " + ((parseInt(props.id) === props.exclusiveTile) ? "active" : "")}
            >
                <div style={{ backgroundImage: ' url(' + image + ')' }}
                     className={"uu-background-image uu-background-image-cover lazyloaded"}
                ></div>
                <div className={"card-overlay"}></div>
                <div className={"card-overlay-text justify-content-center px-20"}>
                    <h3 dangerouslySetInnerHTML={{ __html: props.children }}></h3>
                </div>
            </div>
        </div>
    );
}